import * as React from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/lib/ui/select'
import {
  DocMagnifyingGlass,
  ChatBubble,
  LightBulbOn,
  Phone,
} from 'iconoir-react'
import { LinkedInIcon } from '../LinkedInIcon'
import { useTranslation } from '~/hooks/useTranslation'

export default function Filters({ setColumnFilters }) {
  const filterValues = [
    ['ServiceRequest::ResumeReview', 'resume'],
    ['ServiceRequest::OrientationCall', 'orientation'],
    ['ServiceRequest::LinkedInReview', 'linked_in'],
    ['ServiceRequest::CareerPivotPlanning', 'career_pivot'],
  ]

  const handleFilterChange = (value) => {
    setColumnFilters([
      {
        id: 'type',
        value: value,
      },
    ])
  }

  const { t } = useTranslation('ServiceTypeCell')

  return (
    <Select defaultValue={null} onValueChange={handleFilterChange}>
      <SelectTrigger className="text-lg font-medium md:w-1/3">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={null}>{t('view_all')}</SelectItem>
        {filterValues.map((filterValue, index) => (
          <SelectItem key={index} value={filterValue[0]}>
            <div className="flex items-center gap-4">
              <FilterIcon value={filterValue[0]} />
              {t(filterValue[1])}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

const FilterIcon = ({ value }) => {
  const iconMap = {
    'ServiceRequest::ResumeReview': DocMagnifyingGlass,
    'ServiceRequest::LinkedInReview': LinkedInIcon,
    'ServiceRequest::InterviewPrep': ChatBubble,
    'ServiceRequest::OrientationCall': Phone,
    'ServiceRequest::CareerPivotPlanning': LightBulbOn,
  }

  const Icon = iconMap[value]

  if (!Icon) return null
  return <Icon className={'w-5'} />
}
